

















































































































import Vue from 'vue';

import Url from '@/utils/Url';

import Movie from '@/models/soukai/Movie';

import MoviePoster from '@/components/MoviePoster.vue';

interface ExternalModel {
    url: string;
    domain: string;
    icon: string | null;
}

const DOMAIN_ICONS: { [domain: string]: string } = {
    'imdb.com': 'imdb',
    'themoviedb.org': 'tmdb',
};

export default Vue.extend({
    components: {
        MoviePoster,
    },
    props: {
        movie: {
            type: Object as () => Movie,
            required: true,
        },
    },
    computed: {
        externalModels(): ExternalModel[] | null {
            if (!this.movie)
                return null;

            return this.movie.externalUrls.map(url => {
                const domain = Url.parseRootDomain(url) as string;

                return {
                    url,
                    domain,
                    icon: DOMAIN_ICONS[domain] || null,
                };
            });
        },
    },
    methods: {
        async markWatched() {
            if (!this.movie || this.movie.watched)
                return;

            await this.$ui.updateModel(this.movie, movie => movie.watch());
        },
        async markWatchLater() {
            if (!this.movie)
                return;

            if (!(await this.$ui.confirm('Mark this movie to watch later?')))
                return;

            await this.$ui.loading(
                async () => {
                    await this.movie!.loadRelationIfUnloaded('actions');
                    await Promise.all(this.movie!.actions!.map(action => action.delete()));

                    this.movie!.setRelationModels('actions', []);
                },
                `Marking **${this.movie.title}** to watch later`,
            );
        },
        async deleteMovie() {
            if (!this.movie)
                return;

            if (!(await this.$ui.confirm('Delete this movie?')))
                return;

            this.$router.push({ name: this.$media.movies.length === 1 ? 'home' : 'collection' });

            await this.$ui.loading(
                async () => {
                    await this.$media.removeMovie(this.movie!);
                    await this.movie!.delete();
                },
                `Deleting **${this.movie.title}**...`,
            );

            this.$ui.showSnackbar(
                `**${this.movie.title}** has been removed from your collection.`,
                { transient: true },
            );
        },
    },
});
